(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("publicResource", ["$resource", publicResource]);
    function publicResource($resource) {
        return $resource("/api/public/:action/:subAction/:actionValue", { action: "@action", actionValue: "@actionValue" }, {
            isUsernameAvailable: {
                method: "GET",
                params: { action: "isUsernameAvailable" }
            },
            emailExists: {
                method: "GET",
                params: { action: "emailExists" }
            },
            isPasswordResetTokenValid: {
                method: "GET",
                params: { action: "isPasswordResetTokenValid" }
            },
            passwordReset: {
                method: "POST",
                params: { action: "passwordReset" }
            },
            contactUs: {
                method: "POST",
                params: { action: "contactUs" }
            },
            requestPasswordReset: {
                method: "POST",
                params: { action: "requestPasswordReset" }
            },
            getSelfRegistrationSettings: {
                method: "GET",
                params: { action: "self-registration" }
            },
            saveSelfRegistration: {
                method: "POST",
                params: { action: "self-registration" }
            },
            getPreregistrationViewModel: {
                method: "GET",
                params: { action: "preregistrationViewModel" }
            },
            savePreregistration: {
                method: "POST",
                params: { action: "preregistration" }
            },
            saveCheckoutRegistration: {
                method: "POST",
                params: { action: "checkout-registration" }
            },
            verifyEmail: {
                method: "POST",
                params: { action: "verify-email" }
            },
            getExamAttemptRequest: {
                method: "GET",
                params: { action: "exam-attempt-request" }
            },
            saveExamAttemptRequestResult: {
                method: "POST",
                params: { action: "exam-attempt-request" }
            },
            resendEmailVerificationEmail: {
                method: "POST",
                params: { action: "resend-email-verification-email" }
            },
            notificationUnsubscribe: {
                method: "POST",
                params: { action: "notification-unsubscribe" }
            },
            viewOrderDetails: {
                method: "GET",
                params: { action: "view-order" }
            },
            homePage: {
                method: "GET",
                params: { action: "home-page" }
            },
            getRegistrationNumberList: {
                method: "GET",
                params: { action: "registrationNumbers" },
                isArray: true
            },
            certificationCheck: {
                method: "POST",
                params: { action: "certificationCheck" }
            },
            getCertifications: {
                method: "GET",
                params: { action: "certifications" }
            },
            getCertificationExportsForOrganizationView: {
                method: "GET",
                params: { action: "certificationExportsForOrganization" }
            },
            postCertificationExportsForOrganization: {
                method: "POST",
                params: { action: "certificationExportsForOrganization" }
            },
            isSignupCodeValid: {
                method: "GET",
                params: { action: "isSignupCodeValid" }
            },
            getOrganizationNameBySignupCode: {
                method: "GET",
                params: { action: "organization" }
            },
            getOrganizationByUrlCode: {
                method: "GET",
                params: { action: "organization", subAction: "url" }
            }
        });
    }
}());
